import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

import { BracketedWrapper } from '@sorare/core/src/atoms/BracketedWrapper';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconLightningBolt } from '@sorare/core/src/atoms/icons/system/iconLightningBolt';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, BrandS } from '@sorare/core/src/atoms/typography';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

import hero from './assets/hero.webp';
import heroMobile from './assets/hero_mobile.webp';

// Negative margins cancel the gutter `SearchLayoutRoot` puts on every market shop page.
const root = css`
  position: relative;
  margin: 0 calc(-1 * var(--double-unit));
  padding: var(--triple-unit) var(--double-unit);
  background: url(${heroMobile}) center / cover no-repeat;

  @media ${tabletAndAbove} {
    padding: var(--quadruple-unit) var(--double-unit);
    background-image: url(${hero});
  }

  @media ${laptopAndAbove} {
    margin-right: calc(-1 * var(--triple-unit));
  }
`;

const flashSalesPill = css`
  padding: var(--half-unit) var(--intermediate-unit);
  border: 1px solid var(--c-rewards-orange);
  border-radius: 999px;
  background: var(--c-nl-600);
  color: var(--c-rewards-orange);
`;

const title = css`
  text-align: center;
  text-wrap: balance;

  strong {
    font-weight: 700;
  }
`;

export const MatchdayPicksBanner = () => (
  <div className={root}>
    <Vertical center gap={2}>
      <Horizontal className={flashSalesPill} gap={0.5} center>
        <FontAwesomeIcon icon={iconLightningBolt} size="xs" />
        <BrandS>
          <FormattedMessage defaultMessage="Flash sales" />
        </BrandS>
      </Horizontal>

      <BracketedWrapper
        style={{ '--border-color': 'var(--c-rewards-orange)' } as CSSProperties}
      >
        <BrandL className={title}>
          <FormattedMessage
            defaultMessage="<strong>Matchday</strong> picks"
            values={{ strong: chunks => <strong>{chunks}</strong> }}
          />
        </BrandL>
      </BracketedWrapper>
    </Vertical>
  </div>
);
